import { render, staticRenderFns } from "./excel-preview.vue?vue&type=template&id=150119f6&scoped=true"
import script from "./excel-preview.vue?vue&type=script&lang=js"
export * from "./excel-preview.vue?vue&type=script&lang=js"
import style0 from "./excel-preview.vue?vue&type=style&index=0&id=150119f6&prod&lang=scss"
import style1 from "./excel-preview.vue?vue&type=style&index=1&id=150119f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150119f6",
  null
  
)

export default component.exports